import List from './SSM';
// import Label from './QALabel';
import Records from './QARecords';

export default {
  displayNameKey: 'ssm',
  icon: 'menu_ssm',
  pages: {
    List,
    // Label,
    Records,
  },
};



// WEBPACK FOOTER //
// ./src/modules/SSM/index.js